
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podatek-od-srodkow-transportowych",
      function () {
        return require("private-next-pages/podatek-od-srodkow-transportowych/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podatek-od-srodkow-transportowych"])
      });
    }
  